require('./accountNewChequebookSuccess.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { OKLink } = require('commonsComponents/OKLink');
// @ helpers
const {FormattedText, formatText} = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
// @ components
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

class AccountNewChequebookSuccess extends React.Component {

    componentWillUnmount() {
        this.props.clearAccountNewChequebook();
    }

    render() {
        const { accountId, accountAlias, immProfile } = this.props;
        const exitLink = `/myprofile/accounts/${accountId}/cheques`;
        const registeredAddress = PersonalDataHelper.getFormattedAddress(immProfile);
        const title = formatText('accountNewChequebook-successMessage');

        return (
            <WizardSuccess successMessage={title}>
                <FormattedText
                    className="account-new-chequebook-success__message-send"
                    injectedStrings={[accountAlias]}
                    value="accountNewChequebook-messageWillSend"
                />
                <div className="account-new-chequebook-success__address">
                    <span className="account-new-chequebook-success__location-icon icon-s-locacion"></span> {registeredAddress}
                </div>
                <footer className="account-new-chequebook-success__footer">
                    <OKLink modifier="emphasize" to={exitLink}>
                        <FormattedText value="accountNewChequebook-goToChequebooks" />
                    </OKLink>
                </footer>
            </WizardSuccess>
        );
    }
}

AccountNewChequebookSuccess.propTypes = {
    accountId: PropTypes.string.isRequired,
    accountAlias: PropTypes.string.isRequired,
    clearAccountNewChequebook: PropTypes.func,
    immProfile: PropTypes.object.isRequired
};

module.exports = AccountNewChequebookSuccess;
